import classnames from 'classnames';
import type { IconColor } from '../../common';
import { Icon } from '../../common';
import styles from './IconText.module.css';

interface IIconTextProps {
    className?: string;
    color?: IconColor;
    icon: string;
    iconSize?: 'small' | 'medium' | 'large';
    tag: 'h3' | 'p';
    text: string;
}

export function IconText(props: IIconTextProps) {
    return (
        <div className={classnames(styles.iconText, props.className || '')}>
            <div className={classnames(styles.iconWrap, props.iconSize ? styles[props.iconSize] : '')}>
                <Icon
                    className={styles.icon}
                    color={props.color}
                    icon={props.icon}
                />
            </div>
            <props.tag className={classnames(styles.text, `has-text-${props.color}`)}>{props.text}</props.tag>
        </div>
    );
}

IconText.defaultProps = {
    tag: 'p',
    iconSize: 'small',
};
